{
  "HELP_CENTER": {
    "TITLE": "Centro de suporte",
    "NEW_PAGE": {
      "DESCRIPTION": "Crie portais de centro de ajuda de self-service para os seus clientes. Ajude-os a encontrar respostas rapidamente, sem esperar. Simplifique os pedidos, aumente a eficiência dos agentes e melhore o apoio ao cliente.",
      "CREATE_PORTAL_BUTTON": "Criar portal"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Sem título"
    },
    "HEADER": {
      "FILTER": "Filtrar por",
      "SORT": "Ordenar por",
      "LOCALE": "Linguagem",
      "SETTINGS_BUTTON": "Configurações",
      "NEW_BUTTON": "Novo artigo",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Publicado",
        "DRAFT": "Draft",
        "ARCHIVED": "Arquivado"
      },
      "TITLES": {
        "ALL_ARTICLES": "Todos os artigos",
        "MINE": "Meus artigos",
        "DRAFT": "Artigos Draft",
        "ARCHIVED": "Artigos arquivados"
      },
      "LOCALE_SELECT": {
        "TITLE": "Selecionar linguagem",
        "PLACEHOLDER": "Selecionar linguagem",
        "NO_RESULT": "Nenhuma linguagem encontrada",
        "SEARCH_PLACEHOLDER": "Procurar linguagem"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Todos os artigos",
      "PUBLISH_BUTTON": "Publicar",
      "MOVE_TO_ARCHIVE_BUTTON": "Mover para arquivo",
      "PREVIEW": "Pré-visualizar",
      "ADD_TRANSLATION": "Adicionar tradução",
      "OPEN_SIDEBAR": "Abrir barra lateral",
      "CLOSE_SIDEBAR": "Fechar barra lateral",
      "SAVING": "A guardar...",
      "SAVED": "Guardado"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Carregar imagem",
        "UPLOADING": "A carregar...",
        "SUCCESS": "Imagem carregada com sucesso",
        "ERROR": "Erro ao carregar imagem",
        "UN_AUTHORIZED_ERROR": "Não tem autorização para carregar imagens",
        "ERROR_FILE_SIZE": "O tamanho da imagem deve ser inferior a {size}MB",
        "ERROR_FILE_FORMAT": "O formato da imagem deve ser jpg, jpeg ou png",
        "ERROR_FILE_DIMENSIONS": "As dimensões da imagem devem ser menores que 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Inserir âncora",
        "TITLE": "Inserir âncora",
        "SUBMIT": "Inserir",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Configurações de artigo",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Categoria",
          "TITLE": "Selecionar categoria",
          "PLACEHOLDER": "Selecionar categoria",
          "NO_RESULT": "Nenhuma categoria encontrada",
          "SEARCH_PLACEHOLDER": "Pesquisar categoria"
        },
        "AUTHOR": {
          "LABEL": "Autor",
          "TITLE": "Selecionar autor",
          "PLACEHOLDER": "Selecionar autor",
          "NO_RESULT": "Nenhum autor encontrado",
          "SEARCH_PLACEHOLDER": "Procurar autor"
        },
        "META_TITLE": {
          "LABEL": "Título meta",
          "PLACEHOLDER": "Adicionar título meta"
        },
        "META_DESCRIPTION": {
          "LABEL": "Descrição meta",
          "PLACEHOLDER": "Adicione a sua descrição meta para melhorar os resultados de SEO..."
        },
        "META_TAGS": {
          "LABEL": "Tags meta",
          "PLACEHOLDER": "Adicione tags meta separadas por vírgula..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Arquivar artigo",
        "DELETE": "Apagar artigo"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Sem categoria",
      "SEARCH_RESULTS": "Procurar resultados para {query}",
      "EMPTY_TEXT": "Pesquisar artigos para inserir em respostas.",
      "SEARCH_LOADER": "A pesquisar...",
      "INSERT_ARTICLE": "Inserir",
      "NO_RESULT": "Nenhum artigo encontrado",
      "COPY_LINK": "Copiar link do artigo para a área de transferência",
      "OPEN_LINK": "Abrir artigo numa nova aba",
      "PREVIEW_LINK": "Pré-visualizar artigo"
    },
    "PORTAL": {
      "HEADER": "Portais",
      "DEFAULT": "Padrão",
      "NEW_BUTTON": "Novo portal",
      "ACTIVE_BADGE": "Ativa",
      "CHOOSE_LOCALE_LABEL": "Selecionar linguagem",
      "LOADING_MESSAGE": "A carregar portais...",
      "ARTICLES_LABEL": "Artigos",
      "NO_PORTALS_MESSAGE": "Não há portais disponíveis",
      "ADD_NEW_LOCALE": "Adicionar nova linguagem",
      "POPOVER": {
        "TITLE": "Portais",
        "PORTAL_SETTINGS": "Configurações do portal",
        "SUBTITLE": "Tem vários portais e pode ter diferentes linguagens para cada portal.",
        "CANCEL_BUTTON_LABEL": "Cancelar",
        "CHOOSE_LOCALE_BUTTON": "Selecionar linguagem"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "Artigos",
            "ADD": "Adicionar linguagem",
            "VISIT": "Abrir site",
            "SETTINGS": "Configurações",
            "DELETE": "Excluir"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Configurações do portal",
            "ITEMS": {
              "NAME": "Nome",
              "DOMAIN": "Domínio personalizado",
              "SLUG": "Slug",
              "TITLE": "Título do portal",
              "THEME": "Cor do tema",
              "SUB_TEXT": "Sub texto do portal"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Linguagens disponíveis",
            "TABLE": {
              "NAME": "Nome do local",
              "CODE": "Código do local",
              "ARTICLE_COUNT": "Número de artigos",
              "CATEGORIES": "Número de categorias",
              "SWAP": "Trocar",
              "DELETE": "Excluir",
              "DEFAULT_LOCALE": "Padrão"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Apagar portal",
          "MESSAGE": "Tem a certeza que pretende apagar este portal",
          "YES": "Sim, apagar portal",
          "NO": "Não, manter portal",
          "API": {
            "DELETE_SUCCESS": "Portal apagado com sucesso",
            "DELETE_ERROR": "Erro ao apagar portal"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Editar portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Informação básica"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Personalização do portal"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Categorias"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Locais"
          }
        },
        "CATEGORIES": {
          "TITLE": "Categorias em",
          "NEW_CATEGORY": "Nova categoria",
          "TABLE": {
            "NAME": "Nome",
            "DESCRIPTION": "Descrição",
            "LOCALE": "Local",
            "ARTICLE_COUNT": "Número de artigos",
            "ACTION_BUTTON": {
              "EDIT": "Editar categoria",
              "DELETE": "Apagar categoria"
            },
            "EMPTY_TEXT": "Nenhuma categoria encontrada"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Atualizar configurações básicas"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informações do centro de ajuda",
            "BODY": "Informações básicas sobre o portal"
          },
          "CUSTOMIZATION": {
            "TITLE": "Personalização do centro de ajuda",
            "BODY": "Personalizar portal"
          },
          "FINISH": {
            "TITLE": "Pronto! 🎉",
            "BODY": "Está tudo pronto!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Voltar",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Criar portal",
            "TITLE": "Informações do centro de ajuda",
            "CREATE_BASIC_SETTING_BUTTON": "Criar configurações básicas do portal"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Personalização do portal",
            "TITLE": "Personalização do centro de ajuda",
            "UPDATE_PORTAL_BUTTON": "Atualizar definições do portal"
          },
          "FINISH_PAGE": {
            "TITLE": "Está tudo pronto! 🎉",
            "MESSAGE": "Agora já pode ver o portal criado na sua página de todos os portais.",
            "FINISH": "Ir para a página de todos os portais"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Carregar logo",
          "HELP_TEXT": "Este logo será exibido no cabeçalho do portal.",
          "IMAGE_UPLOAD_SUCCESS": "Logo carregado com sucesso",
          "IMAGE_UPLOAD_ERROR": "Logo apagado com sucesso",
          "IMAGE_DELETE_ERROR": "Erro ao apagar logo"
        },
        "NAME": {
          "LABEL": "Nome",
          "PLACEHOLDER": "Nome do portal",
          "HELP_TEXT": "O nome será usado internamente no portal público.",
          "ERROR": "Nome obrigatório"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug do portal para URLs",
          "ERROR": "Slug é obrigatório"
        },
        "DOMAIN": {
          "LABEL": "Domínio personalizado",
          "PLACEHOLDER": "Domínio personalizado do portal",
          "HELP_TEXT": "Adicione apenas se quiser utilizar um domínio personalizado para os seus portais. Ex.: {exampleURL}",
          "ERROR": "Insira um URL de domínio válido"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link da Página Inicial",
          "PLACEHOLDER": "Link da página inicial do portal",
          "HELP_TEXT": "O link utilizado para regressar do portal à página inicial. Ex.: {exampleURL}",
          "ERROR": "Insira um URL de página inicial válido"
        },
        "THEME_COLOR": {
          "LABEL": "Cor do tema do portal",
          "HELP_TEXT": "Esta cor será mostrada como a cor do tema do portal."
        },
        "PAGE_TITLE": {
          "LABEL": "Título da página",
          "PLACEHOLDER": "Título da página do portal",
          "HELP_TEXT": "O título da página será usado no portal público.",
          "ERROR": "Título da página obrigatório"
        },
        "HEADER_TEXT": {
          "LABEL": "Texto do cabeçalho",
          "PLACEHOLDER": "Texto do cabeçalho do portal",
          "HELP_TEXT": "O texto do cabeçalho do portal será usado no portal visível ao público.",
          "ERROR": "Texto do cabeçalho do portal obrigatório"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal criado com sucesso.",
          "ERROR_MESSAGE_FOR_BASIC": "Não foi possível criar o portal. Por favor, tente novamente.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal atualizado com sucesso.",
          "ERROR_MESSAGE_FOR_UPDATE": "Não foi possível atualizar o portal. Por favor, tente novamente."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Adicionar um novo local",
        "SUB_TITLE": "Isto adiciona um novo local à sua lista de traduções disponíveis.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Local",
          "PLACEHOLDER": "Selecione um local",
          "ERROR": "Local obrigatório"
        },
        "BUTTONS": {
          "CREATE": "Criar local",
          "CANCEL": "Cancelar"
        },
        "API": {
          "SUCCESS_MESSAGE": "Local adicionado com sucesso",
          "ERROR_MESSAGE": "Não foi possível adicionar o local. Por favor, tente novamente."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Local padrão atualizado com sucesso",
          "ERROR_MESSAGE": "Não foi possível atualizar o local padrão. Por favor, tente novamente."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Local removido do portal com sucesso",
          "ERROR_MESSAGE": "Não foi possível remover o local do portal. Por favor, tente novamente."
        }
      }
    },
    "TABLE": {
      "404": "Nenhum artigo corresponde à sua pesquisa 🔍",
      "LOADING_MESSAGE": "A carregar artigos...",
      "NO_ARTICLES": "Não há artigos disponíveis",
      "HEADERS": {
        "TITLE": "Título",
        "CATEGORY": "Categoria",
        "READ_COUNT": "Visualizações",
        "STATUS": "Estado",
        "LAST_EDITED": "Última edição"
      },
      "COLUMNS": {
        "BY": "por",
        "AUTHOR_NOT_AVAILABLE": "Autor não disponível"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "A carregar artigo...",
      "TITLE_PLACEHOLDER": "Título do artigo aqui",
      "CONTENT_PLACEHOLDER": "Escreva o seu artigo aqui",
      "API": {
        "ERROR": "Erro ao guardar artigo"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Erro ao publicar artigo",
        "SUCCESS": "Artigo publicado com sucesso"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Erro ao arquivar artigo",
        "SUCCESS": "Artigo arquivado com sucesso"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Erro ao definir artigo como Draft",
        "SUCCESS": "Artigo definido como Draft com sucesso"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Confirmar exclusão",
          "MESSAGE": "Tem a certeza que pretende excluir o artigo?",
          "YES": "Sim, excluir",
          "NO": "Não, manter"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Artigo excluído com sucesso",
        "ERROR_MESSAGE": "Erro ao excluir artigo"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Adicione o título do artigo e o conteúdo em seguida, posteriormente as configurações apenas serão editáveis por si"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Pesquisar artigos"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Criar categoria",
        "SUB_TITLE": "A categoria será usada no portal público para categorizar artigos.",
        "PORTAL": "Portal",
        "LOCALE": "Local",
        "NAME": {
          "LABEL": "Nome",
          "PLACEHOLDER": "Nome da categoria",
          "HELP_TEXT": "O ícone e o nome da categoria serão usados no portal público para categorizar artigos.",
          "ERROR": "Nome obrigatório"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Categoria slug para URLs",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug obrigatória"
        },
        "DESCRIPTION": {
          "LABEL": "Descrição",
          "PLACEHOLDER": "Breve descrição da categoria.",
          "ERROR": "Descrição obrigatória"
        },
        "BUTTONS": {
          "CREATE": "Criar categoria",
          "CANCEL": "Cancelar"
        },
        "API": {
          "SUCCESS_MESSAGE": "Categoria criada com sucesso",
          "ERROR_MESSAGE": "Não é possível criar a categoria"
        }
      },
      "EDIT": {
        "TITLE": "Editar uma categoria",
        "SUB_TITLE": "Editar uma categoria atualizará a categoria no portal público.",
        "PORTAL": "Portal",
        "LOCALE": "Local",
        "NAME": {
          "LABEL": "Nome",
          "PLACEHOLDER": "Nome da categoria",
          "HELP_TEXT": "O ícone e o nome da categoria serão usados no portal público para categorizar artigos.",
          "ERROR": "Nome obrigatório"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Categoria slug para URLs",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug é obrigatório"
        },
        "DESCRIPTION": {
          "LABEL": "Descrição",
          "PLACEHOLDER": "Breve descrição da categoria.",
          "ERROR": "Descrição é obrigatória"
        },
        "BUTTONS": {
          "CREATE": "Atualizar categoria",
          "CANCEL": "Cancelar"
        },
        "API": {
          "SUCCESS_MESSAGE": "Categoria atualizada com sucesso",
          "ERROR_MESSAGE": "Não foi possível atualizar a categoria"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Categoria apagada com sucesso",
          "ERROR_MESSAGE": "Não é possível apagar a categoria"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Pesquisar artigos",
      "PLACEHOLDER": "Pesquisar artigos",
      "NO_RESULT": "Nenhum artigo encontrado",
      "SEARCHING": "A pesquisar...",
      "SEARCH_BUTTON": "Procurar",
      "INSERT_ARTICLE": "Inserir link",
      "IFRAME_ERROR": "O URL está vazio ou é inválido. Não é possível exibir o conteúdo.",
      "OPEN_ARTICLE_SEARCH": "Inserir artigo do centro de ajuda",
      "SUCCESS_ARTICLE_INSERTED": "Artigo inserido com sucesso",
      "PREVIEW_LINK": "Pré-visualizar artigo",
      "CANCEL": "Fechar",
      "BACK": "Voltar",
      "BACK_RESULTS": "Voltar aos resultados"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Centro de suporte",
      "DESCRIPTION": "Crie portais self-service de fácil utilização. Ajude os seus utilizadores a aceder aos artigos e obter suporte 24/7. Atualize a sua subscrição para habilitar este recurso.",
      "SELF_HOSTED_DESCRIPTION": "Crie portais self-service de fácil utilização. Ajude os seus utilizadores a aceder aos artigos e obter suporte 24/7. Entre em contacto com o administrador para ativar este recurso.",
      "BUTTON": {
        "LEARN_MORE": "Saiba mais",
        "UPGRADE": "Atualizar"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Múltiplos portais",
          "DESCRIPTION": "Crie vários portais de ajuda centralizada para diferentes produtos usando a mesma conta."
        },
        "LOCALES": {
          "TITLE": "Suporte total para linguagens",
          "DESCRIPTION": "Localize o portal na sua linguagem. Suportamos todas as linguagens e permitimos traduções para todos os artigos."
        },
        "SEO": {
          "TITLE": "Design SEO-friendly",
          "DESCRIPTION": "Personalize as suas meta tags para melhorar a visibilidade nos motores de busca com as nossas páginas SEO-friendly."
        },
        "API": {
          "TITLE": "Suporte completo da API",
          "DESCRIPTION": "Use o portal como um CMS com frameworks de front-end externos usando as nossas APIs."
        }
      }
    },
    "LOADING": "A carregar...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} visualização | {count} visualizações",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publicar",
            "DRAFT": "Draft",
            "ARCHIVE": "Arquivar",
            "DELETE": "Excluir"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Publicado",
            "ARCHIVED": "Arquivado"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Sem categoria"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Todos os artigos",
          "MINE": "Minhas",
          "DRAFT": "Draft",
          "PUBLISHED": "Publicado",
          "ARCHIVED": "Arquivado"
        },
        "CATEGORY": {
          "ALL": "Todas as categorias"
        },
        "LOCALE": {
          "ALL": "Todas as linguagens"
        },
        "NEW_ARTICLE": "Novo artigo"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Escreva um artigo",
          "SUBTITLE": "Escreva um artigo completo, vamos começar!",
          "BUTTON_LABEL": "Novo artigo"
        },
        "MINE": {
          "TITLE": "Ainda não escreveu nenhum artigo aqui",
          "SUBTITLE": "Todos os artigos escritos por si aparecem aqui para acesso rápido."
        },
        "DRAFT": {
          "TITLE": "Não há artigos em Draft",
          "SUBTITLE": "Os artigos Draft aparecerão aqui"
        },
        "PUBLISHED": {
          "TITLE": "Não há artigos publicados",
          "SUBTITLE": "Os artigos publicados aparecerão aqui"
        },
        "ARCHIVED": {
          "TITLE": "Não há artigos no arquivo",
          "SUBTITLE": "Os artigos arquivados não aparecem no portal; pode usá-los para marcar páginas obsoletas ou desatualizadas"
        },
        "CATEGORY": {
          "TITLE": "Não há artigos nesta categoria",
          "SUBTITLE": "Os artigos desta categoria aparecerão aqui"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nova categoria",
        "EDIT_CATEGORY": "Editar categoria",
        "CATEGORIES_COUNT": "{n} categoria | {n} categorias",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Categorias ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} artigos) | {categoryName} ({categoryCount} artigo)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Nenhuma categoria encontrada",
        "SUBTITLE": "As categorias aparecerão aqui. Pode adicionar uma categoria clicando no botão \"Nova categoria\"."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} artigo | {count} artigos",
        "EXPAND": "Mostrar subcategorias",
        "COLLAPSE": "Ocultar subcategorias",
        "MENU": {
          "NEW_ARTICLE": "Novo artigo",
          "ADD_SUBCATEGORY": "Adicionar subcategoria",
          "EDIT": "Editar",
          "DELETE": "Excluir"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria criada com sucesso",
            "ERROR_MESSAGE": "Não é possível criar a categoria"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria atualizada com sucesso",
            "ERROR_MESSAGE": "Não foi possível atualizar a categoria"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria apagada com sucesso",
            "ERROR_MESSAGE": "Não é possível apagar a categoria"
          },
          "CONFIRM": {
            "TITLE": "Excluir categoria",
            "DESCRIPTION": "Tem a certeza que pretende excluir esta categoria? Os seus artigos ficarão sem categoria.",
            "DESCRIPTION_WITH_CHILDREN": "Tem a certeza que pretende excluir esta categoria? Os seus artigos ficarão sem categoria e a sua {count} subcategoria será movida para o nível superior. | Tem a certeza que pretende excluir esta categoria? Os seus artigos ficarão sem categoria e as suas {count} subcategorias serão movidas para o nível superior.",
            "CONFIRM": "Excluir"
          }
        },
        "HEADER": {
          "CREATE": "Criar categoria",
          "EDIT": "Editar categoria",
          "DESCRIPTION": "Editar uma categoria atualizará a categoria no portal público.",
          "PORTAL": "Portal",
          "LOCALE": "Local"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Nome:",
            "PLACEHOLDER": "Nome da categoria",
            "ERROR": "Nome é obrigatório"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Categoria slug para URLs",
            "ERROR": "Slug obrigatória",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Descrição",
            "PLACEHOLDER": "Breve descrição da categoria.",
            "ERROR": "Descrição é obrigatória"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Categoria principal",
            "PLACEHOLDER": "Selecionar uma categoria principal",
            "NONE": "Nenhuma (nível superior)"
          }
        },
        "BUTTONS": {
          "CREATE": "Criar",
          "EDIT": "Atualizar",
          "CANCEL": "Cancelar"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Sem linguagens disponíveis | {n} linguagem | {n} linguagens",
      "NEW_LOCALE_BUTTON_TEXT": "Nova linguagem",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} artigo | {count} artigos",
        "CATEGORIES_COUNT": "{count} categoria | {count} categorias",
        "DEFAULT": "Padrão",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Tornar padrão",
          "DELETE": "Excluir"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Adicionar nova linguagem",
        "DESCRIPTION": "Selecione o idioma em que este artigo será escrito. Será adicionado à sua lista de traduções e poderá adicionar mais idiomas mais tarde.",
        "COMBOBOX": {
          "PLACEHOLDER": "Selecionar linguagem..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Local adicionado com sucesso",
          "ERROR_MESSAGE": "Não foi possível adicionar o local. Por favor, tente novamente."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "A guardar...",
          "SAVED": "Guardado"
        },
        "PREVIEW": "Pré-visualizar",
        "PUBLISH": "Publicar",
        "DRAFT": "Draft",
        "ARCHIVE": "Arquivar",
        "BACK_TO_ARTICLES": "Voltar aos artigos"
      },
      "DRAFT": {
        "PENDING_LABEL": "Alterações não publicadas",
        "PROMOTE": "Publicar alterações",
        "DISCARD": "Descartar alterações",
        "PROMOTE_SUCCESS": "Alterações do Draft publicadas no artigo",
        "PROMOTE_ERROR": "Não foi possível publicar as alterações do Draft",
        "DISCARD_SUCCESS": "Alterações do Draft descartadas",
        "DISCARD_ERROR": "Não foi possível descartar as alterações do Draft"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Histórico de versões",
        "TITLE": "Histórico de versões",
        "BACK": "Voltar ao artigo",
        "LOADING": "A carregar versões...",
        "EMPTY": "Ainda não existem versões. As alterações a este artigo aparecerão aqui.",
        "EMPTY_CONTENT": "Esta versão não tem conteúdo.",
        "CURRENT_BADGE": "Atual",
        "RESTORED_BADGE": "Restaurada",
        "AUTOMATED_USER": "Atualização automática",
        "RESTORE": "Restaurar esta versão",
        "RESTORE_DIALOG": {
          "TITLE": "Restaurar esta versão?",
          "DESCRIPTION": "O artigo volta à redação desta versão. Nada se perde — o texto atual mantém-se no histórico e, se o artigo estiver publicado, continua a mostrar a versão em direto até publicar a alteração.",
          "CONFIRM": "Restaurar"
        },
        "RESTORE_SUCCESS": "Versão restaurada",
        "RESTORE_ERROR": "Não foi possível restaurar esta versão",
        "FETCH_ERROR": "Não foi possível carregar o histórico de versões"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Mais propriedades",
        "TRANSLATE": "Traduzir",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Sem categoria",
        "EDITOR_PLACEHOLDER": "Escreva algo...",
        "HTML_EMBED": {
          "TITLE": "Inserir HTML personalizado",
          "DESCRIPTION": "Cole HTML em bruto, como um iframe, um embed ou um fragmento de widget. Será apresentado tal como está no artigo publicado.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Inserir"
        },
        "PRIMARY_CATEGORY": "Categoria principal"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Propriedades do artigo",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Descrição meta",
        "META_DESCRIPTION_PLACEHOLDER": "Adicionar descrição meta",
        "META_TITLE": "Título meta",
        "META_TITLE_PLACEHOLDER": "Adicionar título meta",
        "META_TAGS": "Tags meta",
        "META_TAGS_PLACEHOLDER": "Adicionar tags meta",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Variantes de idioma",
        "LANGUAGE_MUTATIONS_EMPTY": "Ainda não há artigos vinculados",
        "ADD_MUTATION": "Adicionar",
        "REMOVE_MUTATION": "Remover"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Vincular variantes de idioma",
        "SEARCH_PLACEHOLDER": "Pesquisar artigos por título",
        "EMPTY": "Nenhum artigo correspondente",
        "CANCEL": "Cancelar",
        "ADD_SELECTED": "Adicionar selecionados",
        "SUCCESS": "Variantes atualizadas",
        "ERROR": "Falha ao atualizar variantes"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Traduzir artigo",
        "DESCRIPTION": "Selecione os idiomas para os quais pretende traduzir este artigo. Os idiomas que já estiverem traduzidos serão retraduzidos para um Draft para revisão.",
        "EMPTY": "Não há outros idiomas disponíveis.",
        "CONNECTED_BADGE": "Traduzido",
        "CANCEL": "Cancelar",
        "TRANSLATE": "Traduzir",
        "SUCCESS": "A tradução vai começar em breve. Os artigos traduzidos aparecerão em breve como variantes de idioma.",
        "ERROR": "Falha ao iniciar a tradução"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Erro ao guardar artigo"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Novo portal",
      "PORTALS": "Portais",
      "CREATE_PORTAL": "Criar e gerir vários portais",
      "ARTICLES": "Artigos",
      "DOMAIN": "domínio",
      "PORTAL_NAME": "Nome do portal"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Criar novo portal",
      "DESCRIPTION": "Dê um nome ao seu portal e crie um slug de URL simples de usar. Pode alterar ambos mais tarde nas definições.",
      "CONFIRM_BUTTON_LABEL": "Criar",
      "NAME": {
        "LABEL": "Nome:",
        "PLACEHOLDER": "Guia do utilizador",
        "MESSAGE": "Escolha um nome para o seu portal.",
        "ERROR": "Nome é obrigatório"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug obrigatória",
        "FORMAT_ERROR": "Use apenas letras, números e hífenes, por exemplo: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Não foi possível carregar a imagem! Tente novamente",
          "IMAGE_UPLOAD_SUCCESS": "Imagem adicionada com sucesso. Clique em guardar alterações para guardar o logo",
          "IMAGE_DELETE_SUCCESS": "Logo apagado com sucesso",
          "IMAGE_DELETE_ERROR": "Não foi possível apagar o logo",
          "IMAGE_UPLOAD_SIZE_ERROR": "O tamanho da imagem deve ser inferior a {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Nome:",
          "PLACEHOLDER": "Nome do portal",
          "ERROR": "Nome é obrigatório"
        },
        "HEADER_TEXT": {
          "LABEL": "Texto do cabeçalho",
          "PLACEHOLDER": "Texto do cabeçalho do portal"
        },
        "PAGE_TITLE": {
          "LABEL": "Título da página",
          "PLACEHOLDER": "Título da página do portal"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link da página inicial",
          "PLACEHOLDER": "Link da página inicial do portal",
          "ERROR": "URL inválido. O link da página inicial deve começar com 'http://' ou 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Widget de chat ao vivo",
          "PLACEHOLDER": "Selecionar widget de chat ao vivo",
          "HELP_TEXT": "Selecione um widget de chat ao vivo que aparecerá no seu centro de ajuda"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Acesso público",
          "HELP_TEXT": "Tornar o portal acessível a todos através do link.",
          "OPTIONS": {
            "PUBLIC": "Sim",
            "PRIVATE": "Não"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Destino da ligação",
          "HELP_TEXT": "Escolha se as ligações nos artigos abrem na janela atual ou numa nova.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Janela atual",
            "NEW_WINDOW": "Nova janela"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Tamanho padrão da imagem",
          "HELP_TEXT": "Tamanho aplicado a cada imagem que insere num artigo. Escolha Original para inserir as imagens no seu tamanho de origem e, em vez disso, escolher um tamanho para cada imagem."
        },
        "BRAND_COLOR": {
          "LABEL": "Cor da marca"
        },
        "CUSTOM_HTML": {
          "LABEL": "HTML personalizado",
          "PLACEHOLDER": "<!-- Cole aqui o seu snippet de análise ou de rastreio -->",
          "HELP_TEXT": "Inserido no início da tag <body> em cada página do centro de ajuda. Utilize para o Google Analytics, o Google Tag Manager ou qualquer outro snippet de rastreio. O código é apresentado exatamente como foi introduzido e não é validado."
        },
        "SAVE_CHANGES": "Guardar alterações"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Domínio personalizado",
          "LABEL": "Domínio personalizado:",
          "DESCRIPTION": "Pode alojar o seu portal num domínio personalizado. Por exemplo, se o seu site é yourdomain.com e pretende que o seu portal esteja disponível em docs.yourdomain.com, basta introduzir esse valor neste campo.",
          "PLACEHOLDER": "Domínio personalizado do portal",
          "EDIT_BUTTON": "Editar domínio personalizado",
          "ADD_BUTTON": "Adicionar domínio personalizado",
          "DIALOG": {
            "ADD_HEADER": "Adicionar domínio personalizado",
            "EDIT_HEADER": "Editar domínio personalizado",
            "ADD_CONFIRM_BUTTON_LABEL": "Adicionar domínio",
            "EDIT_CONFIRM_BUTTON_LABEL": "Atualizar domínio",
            "LABEL": "Domínio personalizado",
            "PLACEHOLDER": "Domínio personalizado do portal",
            "ERROR": "Domínio personalizado obrigatório"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Configuração de DNS",
            "DESCRIPTION": "Inicie sessão na conta que tem com o seu fornecedor de DNS e adicione o registo CNAME abaixo para o seu subdomínio.",
            "HELP_TEXT": "Depois de concluído, pode contactar o nosso suporte para solicitar o certificado SSL gerado automaticamente.",
            "CONFIRM_BUTTON_LABEL": "Entendi!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Excluir {portalName}",
          "HEADER": "Apagar portal",
          "DESCRIPTION": "Excluir permanentemente este portal. Esta ação é irreversível",
          "DIALOG": {
            "HEADER": "Tem a certeza que pretende excluir {portalName}?",
            "DESCRIPTION": "Esta é uma ação permanente que não pode ser revertida.",
            "CONFIRM_BUTTON_LABEL": "Excluir"
          }
        },
        "EDIT_CONFIGURATION": "Editar configuração"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal criado com sucesso",
          "ERROR_MESSAGE": "Não foi possível criar o portal"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal atualizado com sucesso",
          "ERROR_MESSAGE": "Não foi possível atualizar o portal"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Anexos",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Adicionar ficheiro",
      "DROP_HERE": "Arraste e solte ficheiros aqui",
      "COPY_LINK": "Copiar link",
      "LINK_COPIED": "Link copiado para a área de transferência",
      "COPY_FAILED": "Falha ao copiar o link",
      "DELETE": "Excluir",
      "CANCEL": "Cancelar",
      "QUEUED": "Em fila",
      "UPLOADING": "A carregar",
      "UPLOAD_FAILED": "Falha ao carregar o ficheiro",
      "FILE_TOO_LARGE": "O ficheiro excede o limite de tamanho de 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Dicionário de tradução",
        "DESCRIPTION": "Os termos definidos aqui são adicionados ao prompt de tradução de IA para que sejam sempre traduzidos da mesma forma. O termo principal é escrito em {locale}."
      },
      "NEW_TERM": "Novo termo",
      "EMPTY_STATE": {
        "TITLE": "Ainda não há termos no dicionário",
        "SUBTITLE": "Adicione um termo e a sua tradução para cada idioma. Quando um artigo é traduzido, estes termos são aplicados para que a terminologia do seu produto se mantenha consistente."
      },
      "LIST": {
        "TERM": "Termo",
        "TRANSLATIONS": "Traduções",
        "ACTIONS": "Ações"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Adicionar termo",
          "EDIT": "Editar termo",
          "DESCRIPTION": "O termo abaixo é aplicado durante a tradução por IA dos artigos do seu centro de ajuda.",
          "PORTAL": "Portal",
          "PRIMARY_LANGUAGE": "Idioma principal"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Termo ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "O termo é obrigatório"
          },
          "DESCRIPTION": {
            "LABEL": "Contexto / notas (opcional)",
            "PLACEHOLDER": "Quando e como este termo é usado, para ajudar o tradutor a desambiguar."
          },
          "TRANSLATIONS": "Traduções",
          "TRANSLATION_PLACEHOLDER": "Deixe em branco para permitir que a IA traduza livremente",
          "AUTO_TRANSLATE": {
            "BUTTON": "Traduzir tudo automaticamente",
            "CONFIRM": "Traduzir para {count} idiomas com IA?",
            "CONFIRM_BUTTON": "Traduzir",
            "CANCEL": "Cancelar",
            "SUCCESS": "Traduções geradas — reveja e guarde",
            "ERROR": "Não foi possível traduzir automaticamente. Por favor, tente novamente."
          }
        },
        "BUTTONS": {
          "CREATE": "Adicionar termo",
          "EDIT": "Guardar",
          "CANCEL": "Cancelar"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Termo adicionado com sucesso",
            "ERROR_MESSAGE": "Não foi possível adicionar o termo. Por favor, tente novamente."
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Termo atualizado com sucesso",
            "ERROR_MESSAGE": "Não foi possível atualizar o termo. Por favor, tente novamente."
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Excluir termo",
          "DESCRIPTION": "Tem a certeza que pretende excluir este termo? Deixará de ser aplicado durante a tradução.",
          "CONFIRM": "Excluir"
        },
        "API": {
          "SUCCESS_MESSAGE": "Termo apagado com sucesso",
          "ERROR_MESSAGE": "Não foi possível apagar o termo. Por favor, tente novamente."
        }
      }
    }
  }
}
